import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { countries } from "../../../enums/countries";
import { useFetch } from "../../../hooks/useFetch";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";
import { Label } from "../../../ui/Label/Label";
import { NavLink } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";
import { useRefreshProducers } from "@/hooks/useRefreshStateHooks/useRefreshProducers";

const AddProducer = () => {
  const [errors, setErrors] = useState([]);
  const { reset, handleSubmit, setValue, control } = useForm({
    defaultValues: {
      name: "",
      country: null,
    },
  });

  const updateItems = useRefreshProducers();

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/producers`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          country_id: formData.country,
        },
      },
    });
    reset();
  };

  useEffect(() => {
    if (!itemSaveResponse) return;
    updateItems();
  }, [itemSaveResponse]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/manufactures"} className="text-sm flex gap-2 items-center text-muted-foreground hover:text-primary"><TbArrowLeft />{t("manufactures")}</NavLink>
            <span className="text-2xl font-semibold">{t('adding_manufacture')}</span>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="px-6">
          <div className="flex flex-col w-full h-full gap-2">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("title_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="country"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("country")}*</Label>
                  <SelectButton
                    label={t("choose_country")}
                    searchable={true}
                    options={countries!}
                    value={value ? countries?.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />

            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddProducer;
